export class UploadEvent {
  public constructor(public readonly files: File[]) {}
}
